import { useFragment } from '@apollo/client';
import { DocInitialBaseFragmentDoc, DocParentFragmentDoc } from '@cycle-app/graphql-codegen';

export const useDocInitialBaseFragment = (docId: string) => {
  const {
    data, complete,
  } = useFragment({
    fragment: DocInitialBaseFragmentDoc,
    fragmentName: 'DocInitialBase',
    from: docId,
  });
  return complete ? data : null;
};

export const useDocParentFragment = (parentDocId: string) => {
  const {
    data, complete,
  } = useFragment({
    fragment: DocParentFragmentDoc,
    fragmentName: 'DocParent',
    from: parentDocId,
  });
  return complete ? data : null;
};
